export default __webpack_public_path__ + "static/media/imageDesignContentFour.1896f0b6.png";